module.exports = {
  language: {
    name: '简体中文',
    title: '选择语言',
    subList: [
      {
        name: 'English',
        link: 'en',
      },
      // {
      //   name: '简体中文',
      //   link: 'zh',
      // },
      {
          name: '繁體中文',
          link: 'tw',
      },
      {
        name: '日本語',
        link: 'jp',
      },
      {
        name: '한국어',
        link: 'kr',
      },
      {
        name: 'ไทย',
        link: 'th',
      },
      {
        name: 'Tiếng Việt',
        link: 'vn',
      },
      {
        name: 'Español',
        link: 'es',
      },
    ]
  },
  "user":{//my
    "wdtd": "My Team",
    "wdyj": "My performance",
    "ren": "person",
  },
  "kjsy": {
    "title": "Revenue",
    "fxsy": "Share revenue",
    "zjlsl": "Total reward amount:",
    "jl": "Reward",
    "sj": "Date",
    "sl": "Quantity",
    "sm": "Description"
  },
  pay:{//purchase
    title: 'Buy mining machine',
    gmsl: 'Purchase Quantity',
    zf: 'Payment',
    kyye: 'Available balance',
    kyyebz: 'Insufficient available balance',
    bztbtips: 'The input withdrawal amount is less than the minimum withdrawal requirement of this currency',
    bztbtips2: 'The withdrawal amount cannot be lower than the minimum withdrawal',
    qsrjymm: 'Please enter a 6-digit transaction password',
    wxts: 'Reminder',
  },
  chongbi:{
    title: 'Deposit',
    lianmc: 'chain type',
    scl: 'Generate exclusive chain',
    sy: 'private key',
    ewm: 'QR code',
    bcewm: 'Save the QR code',
    cbdz: 'Deposit address',
    fz: 'Copy',
    sl: 'Amount of deposit',
    qsrsl: 'Please enter the deposit amount',
    sjczje: 'Actual recharge amount',
    qsrsjczje: 'Please enter the actual recharge amount',
    pzms: 'Certificate description',
    qsrms: 'Please enter a description',
    hxz: 'hash value',
    qsrhxz: 'Please enter the hash value',
    pztp: 'Voucher image',
    qscpztp: 'Please upload the certificate picture',
    fzcg: 'Copy successful',
    yhkcz: 'Bank card recharge',
    usdtcz: 'USDT recharge',
    btccz: 'BTC recharge',
    xzbz: 'Select currency',
    sure: 'confirm',
    ck: 'View',
    "tips1": "Please do not top up any assets that are not in this currency to the above address otherwise the assets cannot be retrieved",
    "tips2": "1. Wallet/platform compatibility: that is, the network is supported; if the target platform does not support your withdrawal network, the assets cannot be retrieved.",
    "tips3": "2. Your top-up network and the target platform are the same; if you choose the target address is the Ethereum network, but the top-up chooses the TRC20 smart chain, you may not be able to retrieve your digital assets.",
    "tips4": "3. Make sure your address and amount are correct before recharging.",
    "tips5": "Reminder: Due to the anonymity and privacy of the block network, once you enter the wrong information, you will lose the corresponding assets. Please check your recharge address and quantity carefully"
  },
  usdttb:{
    title: 'Withdraw',
    lmc: 'chain type',
    xzl: 'Select chain',
    xztbdz: 'Select withdrawal address',
    qsrtbdz: 'Please enter the withdrawal address',
    tbdz: 'withdrawal address',
    qsrdz: 'Please enter the address',
    tbsl: 'Withdrawal amount',
    tbsl2: 'Withdrawal amount:',
    qsrtbsl: 'Please enter the withdrawal amount',
    sjtxje: 'Actual withdrawal amount',
    qsrsjtxje: 'Please enter the actual withdrawal amount',
    dzje:'account amount',
    jymm: 'Transaction password',
    qsrjymm: 'Please enter the transaction password',
    sxf: 'handling fee',
    qsrsxf: 'Please enter the handling fee',
    dzsl: 'Account amount',
    dzsl2: 'Amount of account received:',
    qsrdzsl: 'Please enter the account amount',
    wxts: 'Reminder:',
    mrzdtxcs: 'Minimum withdrawal amount each time:',
    hxxf: 'Need to consume',
    cktx: 'Only available for withdrawal',
    ci: 'times',
    wddtxyq: 'Withdrawal requirements not met',
    tjcg: 'Successful submission, please wait for review',
    tips: 'You can withdraw coins only if your own computing power is greater than 1T (except for experience mining machine computing power) or the computing power under the umbrella is greater than 50T. ',
    dz: 'address',
    qd: 'OK',
    "zdtb": "Minimum Withdrawal"
  },
  kefu: {
    title:'Contact customer service',
    zxkf: 'Customer service',
    fzcg:'Copy successful'
  },
  xgdlmm:{//Modify login password
    title:'Change login password',
    t1:'Current login password',
    t2:'Please enter the current login password',
    t3:'new password',
    t4:'Please enter 6-16 digits and letters',
    t5:'Confirm password',
    t6:'Please enter 6-16 digits and letters',
    t7:'Confirm',
    t8: 'The password is inconsistent with the confirmation password'
  },
  sztxmm:{//Set withdrawal password
    title:'Change transaction password',
    wjtkmm: 'forgot transaction password',
    qsrjdlmm: 'Please enter the current transaction password',
    en: 'Account',
    qsryxhzsj: 'Please enter your email address or mobile phone',
    t1:'Current transaction password',
    t2:'New transaction password',
    t3:'Please enter the 6-digit transaction password',
    t4:'Confirm password',
    t5: 'Forget the transaction password? ',
    t6:'Confirm',
    t7: 'The password is inconsistent with the confirmation password',
    t8:'Transaction Password',
    yzm: 'Verification code',
    qsryzm: 'Please enter the verification code',
    hqyzm: 'Get Verification Code'
  },
  record: {
    cbjl: 'Deposit record',
    tbjl: 'Withdrawal record',
    status:['not reviewed','passed','rejected'],
    bhly: 'Reason for rejection',
    ldz: 'Address:',
    cjsj: 'Creation time:',
    zzsj: 'Transfer time:',
    czl: 'Recharge chain:',
    zrl: 'Transfer chain:',
    jyhx: 'Transaction Hash:'
  },
  yqm: {
    wdyqlj: 'My invitation link',
    wdyqm: 'My invitation code',
    schbyq: 'Generate poster invitation',
    bctp: 'Save picture',
    qx: 'Cancel',
    fx: 'Share',
    yqm: 'Copy invitation code',
    bcewmdxc: 'Save the QR code to the album',
    bcbd: 'save local'
  },
  "wdtd": {
    title: 'My Team',
    td: 'team',
    yqhy: 'Invite friends',
    ren: 'person',
    wdtdzrs: 'The total number of my team',
    uid: 'UID:',
    zh: 'Account:',
    tdrs: 'Team size:',
    zcsj: 'Registration date:'
  },
  "wdyj": {
    title: 'My Performance',
    wdyd: 'my generation',
    dyj: 'performance',
    tdzyj: 'Team total performance',
    uid: 'UID:',
    tdrs: 'Team size:',
    yj: 'Performance:'
  },
  "zc": {
    title: 'Assets',
    zzczh: 'total assets equivalent',
    dh: 'Exchange',
    yczc: 'Assets hidden as 0',
    xj: 'current price',
    zh: 'Converted',
    zcmx: 'Asset Details',
  },
  "duihuang": {
    title: 'Exchange',
    hl: 'Exchange rate',
    zf: 'Payment',
    qbdh: 'Exchange All',
    ky: 'Available',
    dd: 'Get',
    ljdh: 'Redeem now',
    cont: 'Exchange rate changes, subject to the actual amount received',
    yebz: 'Insufficient balance',
    ksslbz: 'Insufficient quantity available',
    qtxje: 'Please enter the quantity',
    dhcg: 'Exchange successful',
    mrcg: 'Buy successful',
    mccg: 'sold successfully',
    wtcg: 'Delegation succeeded',
    ts: 'Prompt',
    btcmTips: 'According to the smart contract settings, GDCC exchange USDT will start on August 8, 2023. ',
    qx: 'Cancel'
  },
  "sign": {
    "title": 'Sign in to receive coins',
    "title2": 'Daily sign-in reward',
    "title3": 'Sign in reward',
    "qd": 'Sign in',
    "yqd": 'Signed in',
    "hdgz": 'Rule details',
    "qdjl": 'Check-in record',
    "qdcg": 'Sign in successfully'
  },
  "langNew": {
    "wd": "My",
    "jd": "Borrowing",
    "jghy": "Futures",
    "xbsg": "Singapore currency purchase",
    "sylx": "Benefit Type",
    "syts": "Days of earnings:",
    "rsy": "Daily income:",
    "rsy2": "Daily income",
    "yjdts": "Number of days borrowed:",
    "jdsy": "Lending income:",
    "jdsy2": "Lending income",
    "jdrq": "Date of loan:",
    "qdsy": "Sign In Benefits",
    "tgsy": "Promotion Benefit",
    "sybl": "Profit Ratio",
    "sybl2": "Profit Ratio:",
    "ljcy": "Join Now",
    "zsy": "Total income",
    "jdrz": "Phrase Match",
    "jiedian": "phrase",
    "qsrje": "Please enter phrases",
    "xyb": "Next",
    "zhye": "Account Balance",
    "dzye": "Address Balance",
    "zhyezh": "Account balance (equivalent)",
    "zq": "Period:",
    "zq2": "period",
    "jdsl": "Loan Amount",
    "yxbd": "Email Verify",
    "qsryxzh": "Please enter your email account",
    "yxgz": "The entered email address does not conform to the rules",
    "jxz": "In progress",
    "ywc": "Completed",
    "day": "days",
    "jg": "Price:",
    "zwsj": "No data~",
    "wyjb": "Borrow",
    "fxjl": "Share Reward",
    "aqsz": "Security Settings",
    "wded": "My second generation",
    "wdsd": "My three generations",
    "dbxe": "Single transaction limit",
    "tjdd": "Submit order",
    "tqsh": "Withdraw Redemption:",
    "shuhui": "Redemption",
    "ljdz": "Link address",
    "yyqh": "Language switch",
    "zxkf": "Customer service",
    "syl": "Daily return",
    "zhuanbi": "Earn coins",
    "zbsy": "Earn currency income",
    "mc": "Name",
    "zxj": "Latest Price",
    "zfb": "Rising List",
    "shouye": "Homepage",
    "gg": "Announcement",
    "rzz": "Certifying",
    "yrz": "Authenticated",
    "rzsb": "Authentication failed, please re-authenticate",
    "cxrz": "Reauthentication",
    "jymmts": "Please go to the security settings to set the transaction password"
  },
  "xbsg":{
    "title": "Newcoin",
    "wdsg": "Details",
    "scts": "Lockup days: ",
    "sy": "Remaining",
    "ljsg": "Subscribe now",
    "ysk": "Sold out",
    "xzjdy": "Subscribe now",
    "dy": "Subscribe",
    "fxjg": "Issue price",
    "fxl": "Circulation",
    "ssrq": "Listing date",
    "yxqx": "Validity period",
    "qsrsl": "Please enter amount",
    "syl": "Remaining",
    "sgrq": "subscribe",
    "sgsl": "Amount",
    "bz": "Coin",
    "yebz": "Insufficient USDT balance",
    "tgsl": "Pass Qty",
    "shz": "Under review",
    "wtg": "Did not pass",
    "ytg": "passed"
  },
  "wydb":{
    "title": "Borrow",
    "db": "Borrow",
    "dbz": "Borrow",
    "jl": "Record",
    "jdzq": "Period (days)",
    "qhk": "To repay",
    "ljdb": "Cumulative",
    "dhkbs" :"pending payment",
    "jkje": "Loan amount",
    "qsrje": "Please enter amount",
    "rll": "Daily interest rate",
    "hkfs": "Repayment",
    "dqych": "Expired",
    "lx": "Interest",
    "fkjg": "Lender",
    "tpsc": "Credit loan (image upload)",
    "fwxx": "Housing information",
    "srzm": "Proof of income (employment relationship)",
    "yhmx": "Bank statement",
    "zjz": "ID photo",
    "yd": "I have read and agreed",
    "xy": "Apply for a loan agreement",
    "sqdb": "Click to apply for loan chains",
    "gb": "close",
    "qd": "OK",
    "ts": "Please check Apply for a loan agreement",
    "dbjl": "Record",
    "hkhth": "Order Code",
    "wsh": "Unreviewed",
    "yfk": "Loan",
    "sqrq": "Application time",
    "zq": "cycle",
    "dbsl": "Number of ribs",
    "zhke": "Total payment",
    "yhkxq": "Repayment Details",
    "bqyhk": "Repayable in the current period(USDT)",
    "hktips": "Please make sure the balance is sufficient, if the balance is insufficient, please recharge first and then repay",
    "bj": "Principal",
    "jie": "Borrow",
    "ljhk": "Repay immediately",
    "qcz": "To deposit",
    "yebzqxcz": "Insufficient balance, please recharge first and then repay",
    "znj": "Late payment fee",
    "yqts": "Days Overdue"
  },
  "hkxq":{
    "dd":"Order",
    "fzhkdz":"Copy the repayment address",
    "hkxq": "Repayment Details",
    "zlx": "total interest",
    "zhk": "total repayments",
    "hkjg": "repayment agency",
    "qschkpz": "Please upload the repayment certificate",
    "hkpz": "repayment certificate"
  },
  "kxt":{
    "gao":"H",
    "di":"L",
    "wtgd":"Order",
    "cj":"Deal",
    "jj":"Info",
    "sj":"Time",
    "fx":"Direction",
    "jg":"Price",
    "sl":"Quantity",
    "mr":"Buy",
    "mc":"Sell",
    "mp":"Bid",
    "sp":"Selling",
    "slb":"Qty",
    "fhsj":"Issuing date",
    "fhsl":"Issuing number",
    "bps":"White Paper",
    "gw":"Official website",
    "fz":"min",
    "xs":"hour",
    "tian":"days",
    "zhou":"week",
    "yue":"month",
    "gd":"More",
    "ft":"Subgraph",
    "zt":"Main graph",
    "sdt":"Depth image",
    "zx":"Favorites",
    "djck": "Click to view"
  },
  "jghy":{
    "jghy": "Futures",
    "yxhy": "Perpetual",
    "mz": "Buy Long",
    "md": "Sell Short",
    "gmj": "Purchase price",
    "jsj": "Settlement price",
    "xj": "Current price",
    "fx": "Direction",
    "sl": "Volume",
    "jgsj": "Delivery time",
    "gb": "Close",
    "jxxd": "Continue to place an order",
    "cclb": "Order list",
    "zc": "Current",
    "lscc": "History",
    "qblx": "All",
    "yk": "Profit",
    "ddqr": "Order Confirmation",
    "dqsj": "Expire time",
    "jssj": "Delivery time",
    "sy": "Profit",
    "tzje": "Investment price",
    "zdje": "Lowest price 0",
    "kyye": "Balance",
    "kyye2": "Balance: ",
    "sxf": "Fee: ",
    "sxfl": "Fee",
    "jypz": "Name",
    "jyfx": "Direction",
    "qrxd": "Confirm",
    "fs": "Line",
    "dqye": "Current balance"
  },
  "zhjl":{
    "title": "Asset History",
    "cbtb":"Deposit & Withdraw",
    "jymx":"Transaction History",
    "tgyj":"Promotion commission",
    "wwc": "Undone",
    "ywc": "Completed"
  },
  "tipsNew":{
    "wjmmts": "Recover password by verification code",
    "qscpztp": "Please upload the voucher image",
    "emailgsts": "Input mailboxes do not conform to the rules",
    "telgsts": "The mobile phone number is incorrect",
    "lcmmbyz": "Please confirm your password",
    "zdsl": "Min Qty ",
    "sldydy": "Quantity greater than or equal to",
    "zxtzsl": "Min Qty ",
    "ddz": "waiting",
    "xs": "hour",
    "min": "Minimum amount ",
    "max": "Maximum amount ",
    "yebz": "Insufficient balance",
    "qsrss": "Please input lots",
    "zdss": "Minimum lots",
    "yjj": "Rejected",
    "shz": "Redemption",
    "zwkfcz": "This currency is not open for deposit",
    "jiaoge": "delivery",
    "zhang": "Rise",
    "die": "Fall",
  },
  "assets": {
    "total": "Asset conversion",
    "avaiable": "Available",
    "conversion": "Conversion",
    "canuse": "Available",
    "yczc":"Assets hidden as 0"
  },
  "status": {
    "statusText": ['failure','waiting','success'],
  },
  "langNew2":{
    "zczgz": "Total assets",
    "hgx": "Compliance",
    "yszc": "Privacy Policy",
    "gywm": "About us",
    "zb": "AI quantification",
    "mnjy": "Simulated Trading",
    "xbzq": "Singapore currency zone",
    "flzq": "Rewards Hub",
    "cjmnzhcg": "Create a demo account successfully!",
    "wdzh": "My Account",
    "yymnzhts": "Already have a virtual account, please do not register again",
    "tcmnzh": "Exit demo account",
    "mnzhgz": "Demo Account Valuation",
    "mnzh": "Demo Account",
    "ljdzsb": "Failed to connect to address",
    "ysq": "Authorized"
  },
  "c2c":{
    "bt": "P2P",
    "bt2": "P2P Payment Service",
    "cjdd": "Create order",
    "mblc": "Fiat currency deposit",
    "cjydd": "Create a pre-order",
    "xmjfk": "Pay to seller",
    "tqhb": "Withdraw your digital currency",
    "ddzt": "Order status",
    "wdys": "Our advantages",
    "c1": "Trade at your preferred price",
    "c2": "Freely buy and sell cryptocurrencies at your preferred price. Buy and sell from existing offers, or create a trade ad to set your ideal price.",
    "c3": "Low Transaction Fee",
    "c4": "Peer-to-peer (P2P) transactions allow sellers to freely define the payment method they want in a transparent way, buying and selling cryptocurrencies through more than 700 payment methods including bank transfer and cash.",
    "c5": "Multiple payment methods",
    "c6": "Peer-to-peer (P2P) trading allows sellers to freely define the payment method they want. Buy and sell cryptocurrencies with more than 700 payment methods, including bank transfers, cash.",
    "wpp": "Not matched",
    "ypp": "Matched",
    "ysx": "Expired",
    "ddh": "Order number",
    "mrje": "Buy amount",
    "mrbz": "Buy currency",
    "nssdgj": "Country",
    "qsrnssdgj": "Please enter country",
    "fkrxm": "Payer Name",
    "qsrfkrxm": "Please enter the payer's name",
    "yx": "Email",
    "qsryx": "Please enter your email address",
    "mmbz": "Purchase type",
    "qxzmmbz": "Please select purchase type",
    "qxz": "Please select",
    "fkfs": "Payment method",
    "qtxfkfs": "Please fill in the payment method",
    "zh": "Account",
    "fb": "Payment currency type",
    "qtxfb": "Please fill in the payment currency type",
    "ngmdje": "Amount of your purchase",
    "qsrje": "Please enter the amount",
    "wxts": "Warm reminder:",
    "dsh": "To be reviewed",
    "ygq": "Expired",
    "jcwdwt": "Introduction to P2P",
    "tjpz": "Submit voucher",
    "ckje": "Match amount",
    "qsrckje": "Please enter the matching amount",
    "tjzzfb": "Transfer copy",
    "tjjzzm": "ID card (front)",
    "tjjzfm": "ID card (back)",
    "psts1": "Pay attention to the following points when shooting",
    "psts2": "Please note that the border of the picture is complete, the font is clear, and the brightness is uniform",
    "psts3": "Please do not upload ID photos that do not match your name",
    "qsczzfb": "Please upload a copy of the transfer",
    "qscjzzm": "Please upload the front of your driver's license",
    "qscjzfm": "Please upload the reverse side of your driver's license",
    "tj": "Submit",
    "je": " Limit range",
    "ljtg": "Place order",
    "sp": "Understand DeFi",
    "xq": "Details",
    "lxkfppdd": "Contact customer service to match the order",
    "szgj": "Country",
    "qsrszgj": "Please enter your country",
    "fkyhmc": "Payment bank name",
    "qsrfkyhmc": "Please enter the payment bank name",
    "dianhui": "Wire Transfer/International Wire Transfer",
    "ccsr": "Enter here"
  },
  "xyf":{
    "title": "Credit score",
    "pgsj": "Evaluation time"
  },
  "bbjy":{
    "mr":"Buy",
    "mc":"Sell",
    "mai":"Purchase",
    "sell":"Sell",
    "xj":"Limit",
    "sj":"Market",
    "pk":"Position",
    "jg":"Price",
    "sl":"Qty",
    "ss":"Quantity",
    "mrl":"Buying volume",
    "mcl":"Selling volume",
    "ky":"Available",
    "km":"Available",
    "ksell":"Marketable",
    "jye":"Turnover",
    "dqwt":"Current entrustment",
    "lswt":"Historical entrustment",
    "jj":"Info",
    "wtzl":"Total",
    "wtjg":"Entrustment price",
    "ycjl":"Completed trading volume",
    "cjjj":"Average transaction price",
    "cd":"Withdrawal",
    "xd":"Order",
    "wqcj":"A complete deal",
    "ywc":"Completed",
    "ycd":"Cancelled order",
    "zx":"Favorites",
    "scjg":"Market price",
    "fhsj":"Issuing date",
    "fhsl":"Issuing number",
    "bps":"White Paper",
    "gw":"Official Website",
    "qx":"Cancel",
    "bbjy": "Exchange"
  },
  "hyjy":{
    "mai":"Purchase",
    "sell":"Sell",
    "kc":"Open positions",
    "pc":"Close positions",
    "cc":"Positions",
    "kp":"Close",
    "kpc":"Close short",
    "kcc":"Positions",
    "kkd":"Open long",
    "kpd":"Long close",
    "kkk":"Open short",
    "xj":"Limit",
    "sj":"Market",
    "xjwt":"Limit order",
    "sjwt":"Market price",
    "pk":"Position",
    "jg":"Price",
    "sl":"Qty",
    "gg":"Lever",
    "tzgg":"Control lever",
    "ggbs": "Leverage",
    "mrl":"Buying volume",
    "ky":"Available",
    "jye":"Turnover",
    "dqwt":"Current entrustments",
    "lswt":"Historical entrustment",
    "ptwt":"Ordinary entrustments",
    "dqwtmr":"Current entrustments(Buy)",
    "dqwtmc":"Current entrustments(Sell)",
    "hywt":"Contract entrustments",
    "jj":"Info",
    "wtzl":"Total",
    "wtjg":"Entrustment price",
    "ycjl":"Completed trading volume",
    "cjjj":"Average transaction price",
    "qbcd":"Withdraw all orders",
    "cd":"Withdrawal",
    "xd":"Order",
    "wqcj":"A complete deal",
    "ywc":"Completed",
    "ycd":"Cancelled order",
    "zx":"Favorites",
    "scjg":"Market price",
    "fhsj":"Issuance date",
    "fhsl":"Issuance number",
    "bps":"White Paper",
    "gw":"Official website",
    "mrzd":"Long open",
    "mrpk":"Short close",
    "mczk":"Short open",
    "mcpd":"Long close",
    "mrkdkz":"Long open (bullish)",
    "mrpkkz":"Short close (bullish) ",
    "mckkkd":"Short open (bearish)",
    "mcpdkd":"Long close (bearish)",
    "yxhy":"Perpetual contract",
    "dc":"Long positions",
    "kcjj":"Open position average price(BUSDT)",
    "wsxyl":"Unrealized profit(BUSDT)",
    "ygqpj":"Estimated strong parity(BUSDT)",
    "syl":"Daily income",
    "cwbzj":"Position margin(BUSDT)",
    "cw":"Positions (No.)",
    "cwjz":"Position value(BUSDT)",
    "bzjl":"Margin rate",
    "kpz":"Close (No.) ",
    "bdzs":"Underlying index",
    "tzbzj":"Adjust margin",
    "zyzs":"Take profit & stop loss",
    "zjbzj":"Increase margin",
    "jsbzj":"Reduce margin",
    "tyhy":"Experience Contract",
    "ccz":"Position (No.)",
    "cwbzjt":"Position margin(TBTC)",
    "zdzjbzj":"Maximum margin increase(TBTC)",
    "zjbzjt":"Margin increase(TBTC)",
    "zhang":"Qty",
    "qblx":"All types",
    "qb":"All",
    "ccjg":"Positions price",
    "ccsl":"Positions Qty",
    "yk":"Profit and loss",
    "ccsj":"Positions time",
    "zy":"Take profit",
    "zs":"Stop loss",
    "zje":"Total amount",
    "kcs":"Open positions Qty",
    "kcjg":"Open positions price",
    "ss":"Lots",
    "hand":"1 lots =",
    "qx":"Cancel",
    "qr":"OK"
  },
  "bbjyNew":{
    "jylx": "Types of",
    "jyze": "Amount"
  },
  "langNew3":{
    "bzxq": "Details of moving bricks",
    "znbz": "AI Quantitative Intelligent Brick Moving",
    "apits": "Seamlessly connect to the APIs of 200+ exchanges around the world",
    "jr": "Join",
    "gn": "Function",
    "lhjs": "Introduction to dividend quantification",
    "jqrts": "How do robots work?",
    "sctj": "Market Statistics",
    "scqk": "Market conditions",
    "jiaoge": "Delivery",
    "zhang": "Rise",
    "die": "Fall",
    "sz": "Settings",
    "qbcp": "All products",
    "jrlh": "Join AI quantification",
    "sywd": "0 risk, stable returns",
    "bzbz": "Crypto type"
  },
  "sztkmm":{
    "title":"Set withdrawal password",
    "dlmm":"Login password",
    "dlmmts":"Please enter the login password",
    "xmm":"New password",
    "mmts":"Password length 6 digits",
    "qrmm":"Confirm password",
    "qr":"OK",
    "qd": "OK",
    "sztkts": "Tip: Please go to the Security Center to set the transaction password"
  },
  "bzhl":{
    "title":"Dividend",
    "gz":"Rules",
    "tgdd":"Escrow order",
    "zztgdzj":"Funds in custody",
    "yjjrsy":"Estimated daily",
    "ljsy":"Total income",
    "tgzdd":"Order in custody",
    "cljxcp":"Strategic campaign products",
    "dbxe":"Limit",
    "rsyl":"Daily rate of return",
    "zq":"Order cycle",
    "qmr":"Go and buy",
    "bbzhzc": "Account assets",
    "zcc": "Total assets(USDT)",
    "dd":"Orders",
    "buy":"Buy in",
    "jxcp":"Featured Products",
    "ckdd":"Check order",
    "gd":"more",
    "xzbzts": "Simple and safe. Dividends can be selected in multiple currencies",
    "qtbz": "Other coins",
    "dj": "Level",
    "cjwt": "Common problems",
    "ddsl": "Order quantity",
    "sl": "Amount"
  },
  "bzhlgm":{
    "title":"Profits from brick removal",
    "bzhld":"Profits from brick removal USDT",
    "qtzq":"USDT 7-day cycle",
    "rsyl":"Daily return rat",
    "lczq":"Financial cycle",
    "dbxe":"Limit ",
    "pxsj":"Dividend payout time",
    "mr":"Daily",
    "dqfh":"Return when due",
    "tgzj":"Custody capital",
    "tqsh":"Early redemption",
    "yjsy":"Anticipated income (USDT)",
    "kyzc":"Available assets (USDT)",
    "cpjs":"About Our Products",
    "tgje":"Enter amount",
    "qsrtgje":"Please enter the custody amount",
    "qb":"All",
    "rm":"Click here",
    "cpzq":"Product cycle",
    "jxr":"Interest calculation date",
    "jiexr":"Interest settlement date",
    "yjdzr":"Estimated arrival date",
    "gz":"Know the rules and interests"
  },
  "bzhlwdtg":{
    "title":"Order status",
    "tgz":"In custody",
    "ywc":"Completed",
    "ysh":"Redeemed",
    "tgje":"Custody amount/Custody time",
    "rsyl":"Daily return rat",
    "yhl":"Profited",
    "xdsj":"Ordering time",
    "sh":"Redemption",
    "ddxq":"Order details",
    "ddh":"Order No. ",
    "syts": "Remaining",
    "ddztxq": "Order Status Details"
  },
  "langNew4":{
    "kp": "Opening",
    "zuoshou": "Received yesterday",
    "zg": "Highest",
    "zd": "Lowest",
    "dqjg": "Current price",
    "pcjg": "Closing price",
    "gd": "Pending order",
    "gdj": "Pending order price",
    "gdjg": "Pending order price",
    "xfbzj": "Security deposit required: ",
    "ksrfw": "Available input range: ",
    "shou": "Lots",
    "fdjyk": "Floating net profit and loss",
    "pcsl": "Closing Quantity",
    "cx": "revoke",
    "qrpc": "Confirm to close the position",
    "sx": "filter",
    "cz": "reset",
    "zdl": "knew",
    "kccg": "Successfully opened a position!",
    "xzfx": "choose direction",
    "lx": "type",
    "xgcc": "modify position",
    "szzyzs": "Set stop profit and stop loss",
    "szhb": "Crypto",
    "gjs": "Metal",
    "yy": "Crude",
    "jy": "Trade",
    "gp": "Stock",
    "jmhb": "Crypto",
    "gdsj": "Pending order time",
    "gdsl": "Pending Order Quantity",
    "fs": "time"
   },
   "deals": {
  	"issue_time":"Time",
    "issue_number": "Number",
    "white_book": "Book",
    "weburl": "Url",
    "video_url": "Video",
    "introduction": "Info",
    "onhand":"one hand equal",
    "position": "Position",
    "leverorder": "Leverage orders",
    "leverposition": "leveraged position",
    "inputprice": "Input price",
    "inputmul": "Input multiple",
    "selectmul": "Choose multiple",
    "onehand": "one hand equals",
    "hand": "Number of trading hands",
    "marketval": "Market Value",
    "bond": "Bond",
    "service": "service fee",
    "balance": "balance",
    "type": "Type",
    "risk": "Risk Rate",
    "total": "total profit",
    "onekey": "closing it",
    "makemore": "(Long)",
    "makeless": "(Short)",
    "current": "Open Orders",
    "all": "All",
    "weing": "In commission",
    "tding": "Trading",
    "ping": "Closing",
    "pied": "Closed",
    "ceiled": "withdrawn",
    "weprice": "commission price",
    "oprice": "Opening price",
    "nowprice": "current price",
    "zyprice": "stop earnings price",
    "zsprice": "stop-loss price",
    "canbond": "available margin",
    "optime": "Opening time",
    "pgtime": "Closing time",
    "znum": "Converted quantity",
    "gprice": "Overnight charges",
    "pcang": "Close",
    "revoke": "Withdrawal",
    "fee": "Fee",
    "you":"Optimal market price"
  },
  "zyzs":{
    "title":"Take profit & stop loss",
    "zy":"Take profit",
    "zs":"Stop loss",
    "qsrzyjg":"Please enter a Take Profit price",
    "qsrzsjg":"Please enter a Stop loss price",
    "cfjglx":"Trigger Price Type:",
    "zsjg":"Index price",
    "scjg":"Market price",
    "pcfs":"Methods to Close positions:",
    "kpcw":"Closeout",
    "qbcw":"All positions",
    "wxts":"Please note:",
    "cont": "The Close positions of the market price may create the possibility of failing to make an order at market price, or to successfully take profit/stop loss due to sharp market fluctuations and other problems.",
    "qr":"OK"
  },
  "ssbt":{
    "ssbt":"Tax Subsidy",
    "ssnhm":"SSN number",
    "qsrssnhm":"Please enter your SSN number",
    "idzmz":"ID front photo",
    "qscidzmz":"Please upload ID front photo",
    "dhfb":"Wire transfer copy",
    "qscdhfb":"Please upload wire transfer copy",
    "srlyfb":"Source of income copy",
    "qscsrlyfb":"Please upload source of income copy",
  },
  "newReg":{
    "sjh": "Mobile",
    "yx": "Email",
    "yqm": "Invitation code",
    "yqm2": "Invitation code (optional)",
    "cjzh": "Create Account",
    "sysjhzyx": "Register with mobile number/email",
    "sj": "Mobile",
    "yhxy": "&lt;User Agreement&gt;",
    "yhxy2": "I have read and agree to the  and  &lt;User Agreement&gt; ",
    "hmyzh":"Haven't got an account yet?",
    "qzc":"Register",
    "qbdl": "Wallet Sign In",
    "qyqbfw": "Please use wallet APP to access",
    "dc": "Sign out"
  },
  "langNew5":{
    "dl":"Connect",
    "ljdz":"Link wallet address",
    "srdz":"Enter address",
    "ljqq":"Connection Request",
    "qq":"Request For",
    "qb":"Wallte",
    "ckyehhd":"View your balance and activity",
    "qqjypz":"Request approval for transactions",
    "cro":"Cronos",
    "jj":"Reject",
    "lj":"Connect",
  }
}



// WEBPACK FOOTER //
// ./src/utils/lang/en.js